import { subjectConstants } from "../constants";


const start = () => {
    return {type: subjectConstants.START, payload: {loading: true}};
};

const stop = () => {
    return {type: subjectConstants.STOP, payload: {loading: false}};
};

const list = (res) => {
    return {type: subjectConstants.SUBJECT, payload: {list: res}};
};

const add = (res) => {
    return {type: subjectConstants.ADD, payload: {add: res}};
};

const update = (res) => {
    return {type: subjectConstants.UPDATE, payload: {update: res}};
};

const remove = (res) => {
    return {type: subjectConstants.REMOVE, payload: {remove: res}};
};

const clear = () => {
    return {type: subjectConstants.CLEAR, payload: {list: []}};
};

export const subjectSelectors = {
    start,
    stop,
    list,
    add,
    update,
    remove,
    clear
}